import { render } from "./LuxuryButton.vue?vue&type=template&id=3a121b08&ts=true"
import script from "./LuxuryButton.vue?vue&type=script&lang=ts"
export * from "./LuxuryButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__